module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer007"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pageix",
      "title": "ix"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "_toc",
    attrs: {
      "id": "_idParaDest-4"
    }
  }, [_vm._v("Contents"), _c('a', {
    attrs: {
      "id": "_idTextAnchor000"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "FM_TOC_Italics2"
  }, [_c('a', {
    attrs: {
      "href": "#/OCC#_idTextAnchor001"
    }
  }, [_c('span', {
    staticClass: "Italic"
  }, [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "FM_TOC_Italics1"
  }, [_c('a', {
    attrs: {
      "href": "#/OCC1#_idTextAnchor002"
    }
  }, [_c('span', {
    staticClass: "Italic"
  }, [_vm._v("Charmed Circle  Foreword")])])]), _vm._v(" "), _c('p', {
    staticClass: "FM_TOC_Chpts"
  }, [_c('span', {
    staticClass: "Brandon _idGenCharOverride-1"
  }, [_vm._v("Chapter 1: "), _c('br')]), _c('a', {
    attrs: {
      "href": "#/OCC2#_idTextAnchor004"
    }
  }, [_vm._v("An Introduction to the Book (and the Author)")])]), _vm._v(" "), _c('p', {
    staticClass: "FM_TOC_Chpts"
  }, [_c('span', {
    staticClass: "Brandon _idGenCharOverride-1"
  }, [_vm._v("Chapter 2: "), _c('br')]), _c('a', {
    attrs: {
      "href": "#/OCC3#_idTextAnchor008"
    }
  }, [_vm._v("Getting Our Bearings, Knowing Our Terms")])]), _vm._v(" "), _c('p', {
    staticClass: "FM_TOC_Chpts"
  }, [_c('span', {
    staticClass: "Brandon _idGenCharOverride-1"
  }, [_vm._v("Chapter 3: "), _c('br')]), _c('a', {
    attrs: {
      "href": "#/OCC4#_idTextAnchor011"
    }
  }, [_vm._v("Embodiment as Magical Praxis")])]), _vm._v(" "), _c('p', {
    staticClass: "FM_TOC_Chpts"
  }, [_c('span', {
    staticClass: "Brandon _idGenCharOverride-1"
  }, [_vm._v("Chapter 4: "), _c('br')]), _c('a', {
    attrs: {
      "href": "#/OCC5#_idTextAnchor015"
    }
  }, [_vm._v("Gender in Theory  and Practice")])]), _vm._v(" "), _c('p', {
    staticClass: "FM_TOC_Chpts"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pagex",
      "title": "x"
    }
  }, [_c('span', {
    staticClass: "Brandon _idGenCharOverride-1"
  }, [_vm._v("Chapter 5: "), _c('br')]), _c('a', {
    attrs: {
      "href": "#/OCC6#_idTextAnchor017"
    }
  }, [_vm._v("Queerness and the Charmed Circle")])])]), _vm._v(" "), _c('p', {
    staticClass: "FM_TOC_Chpts"
  }, [_c('span', {
    staticClass: "Brandon _idGenCharOverride-1"
  }, [_vm._v("Chapter 6: "), _c('br')]), _c('a', {
    attrs: {
      "href": "#/OCC7#_idTextAnchor021"
    }
  }, [_vm._v("Safer Sex Magic for Beginners (and Experts)")])]), _vm._v(" "), _c('p', {
    staticClass: "FM_TOC_Chpts"
  }, [_c('span', {
    staticClass: "Brandon _idGenCharOverride-1"
  }, [_vm._v("Chapter 7: "), _c('br')]), _c('a', {
    attrs: {
      "href": "#/OCC8#_idTextAnchor026"
    }
  }, [_vm._v("Form Follows Function:  Toward a Consent-Based Magical Praxis")])]), _vm._v(" "), _c('p', {
    staticClass: "FM_TOC_Chpts"
  }, [_c('span', {
    staticClass: "Brandon _idGenCharOverride-1"
  }, [_vm._v("Chapter 8: "), _c('br')]), _c('a', {
    attrs: {
      "href": "#/OCC9#_idTextAnchor029"
    }
  }, [_vm._v("Between the Mundane and the Divine: On Negotiating Consent with Gods")])]), _vm._v(" "), _c('p', {
    staticClass: "FM_TOC_Chpts"
  }, [_c('span', {
    staticClass: "Brandon _idGenCharOverride-1"
  }, [_vm._v("Chapter 9: "), _c('br')]), _c('a', {
    attrs: {
      "href": "#/OCC10#_idTextAnchor031"
    }
  }, [_vm._v("Queering Your Praxis: Developing and Adapting Magical Practices")])]), _vm._v(" "), _c('p', {
    staticClass: "FM_TOC_Chpts"
  }, [_c('span', {
    staticClass: "Brandon _idGenCharOverride-1"
  }, [_vm._v("Chapter 10: "), _c('br')]), _c('a', {
    attrs: {
      "href": "#/OCC11#_idTextAnchor034"
    }
  }, [_vm._v("Greater Than One: Thoughts on Politics, Power, and Community")])]), _vm._v(" "), _c('p', {
    staticClass: "FM_TOC_Chpts"
  }, [_c('span', {
    staticClass: "Brandon _idGenCharOverride-1"
  }, [_vm._v("Chapter 11: "), _c('br')]), _c('a', {
    attrs: {
      "href": "#/OCC12#_idTextAnchor037"
    }
  }, [_vm._v("An Ending and a Beginning: What Lies Beyond the Circle")])]), _vm._v(" "), _c('p', {
    staticClass: "FM_TOC_Chpts"
  }, [_c('span', {
    staticClass: "Brandon _idGenCharOverride-1"
  }, [_vm._v("Appendix A: "), _c('br')]), _c('a', {
    attrs: {
      "href": "#/OCC13#_idTextAnchor039"
    }
  }, [_vm._v("Recommended Reading and Listening")])]), _vm._v(" "), _c('p', {
    staticClass: "FM_TOC_Chpts"
  }, [_c('span', {
    staticClass: "Brandon _idGenCharOverride-1"
  }, [_vm._v("Appendix B: "), _c('br')]), _c('a', {
    attrs: {
      "href": "#/OCC14#_idTextAnchor043"
    }
  }, [_vm._v("Queer Magical Groups and Events")])]), _vm._v(" "), _c('p', {
    staticClass: "FM_TOC_Italics2"
  }, [_c('a', {
    attrs: {
      "href": "#/OCC15#_idTextAnchor045"
    }
  }, [_c('span', {
    staticClass: "Italic"
  }, [_vm._v("Bibliography")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2b439491","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Contents.vue
// module id = 69
// module chunks = 0